import { AudioTab } from "@pages:app/analytics/tabs/AudioTab";
import { DocsTab } from "@pages:app/analytics/tabs/DocsTab";
import { GeneralTab } from "@pages:app/analytics/tabs/GeneralTab";
import { SearchTab } from "@pages:app/analytics/tabs/SearchTab";
import { TranslationTab } from "@pages:app/analytics/tabs/TranslationTab";
import {
  AnalyticsData,
  AnalyticsQueryKey,
} from "@pages:app/analytics/tabs/useAnalyticsData";
import { FC } from "react";

import { RequestType } from "@:openapi";

export type AnalyticsTabKey =
  | "general"
  | "search"
  | "docs"
  | "translation"
  | "audio";

export type AnalyticsTabConfig = {
  key: AnalyticsTabKey;
  requestType: RequestType;
  queries: AnalyticsQueryKey[];
  component: FC<{ data: AnalyticsData }>;
};

export const ANALYTICS_TABS: AnalyticsTabConfig[] = [
  {
    key: "general",
    requestType: "all",
    queries: ["summary", "tokenUsage", "requestsByFeature", "topUsers"],
    component: GeneralTab,
  },
  {
    key: "search",
    requestType: "nemoSearch",
    queries: ["summary", "tokenUsage", "feedback", "topUsers", "topDocuments"],
    component: SearchTab,
  },
  {
    key: "docs",
    requestType: "nemoDocs",
    queries: [
      "summary",
      "tokenUsage",
      "topUsers",
      "docsSubtype",
      "docsOperation",
    ],
    component: DocsTab,
  },
  // TODO: Add text translation tab
  {
    key: "translation",
    requestType: "nemoDocumentTranslation",
    queries: [
      "summary",
      "topUsers",
      "translationSummary",
      "languagePairs",
      "translationFileType",
    ],
    component: TranslationTab,
  },
  {
    key: "audio",
    requestType: "nemoAudio",
    queries: [
      "summary",
      "audioSummary",
      "audioLanguage",
      "audioLanguageDuration",
    ],
    component: AudioTab,
  },
];

export const isAnalyticsTabKey = (value: string): value is AnalyticsTabKey =>
  ANALYTICS_TABS.some((tab) => tab.key === value);
